import React from 'react'

function Footer() {
  return (
    <footer className='footer relative flex flex-col bg-gradient-dark text-white w-full border-t border-dark-700'>
      <div className="max-w-7xl w-full mx-auto px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <section className="flex flex-col text-left animate-slide-up">
            <div className='text-left w-full mb-6 pb-4 border-b-2 border-primary-500'>
              <h3 className='text-xl font-bold text-white'>About Us</h3>
            </div>
            <div>
              <p className='text-dark-200 leading-relaxed text-base'>
                BulkClix is an electronic voting website that allows for secure and efficient voting.
                We provide a modern, transparent, and reliable platform for conducting digital elections.
              </p>
            </div>
          </section>

          <section className="flex flex-col text-left animate-slide-up" style={{animationDelay: '0.1s'}}>
            <div className='text-left w-full mb-6 pb-4 border-b-2 border-primary-500'>
              <h3 className='text-xl font-bold text-white'>Contact Us</h3>
            </div>
            <div className="flex flex-col w-full gap-4">
              <div className="flex items-center gap-3 text-dark-200 hover:text-white transition-colors duration-300">
                <i className="fa fa-map-marker text-primary-400 text-lg w-5"></i>
                <p>Accra, Ghana</p>
              </div>
              <div className="flex items-center gap-3 text-dark-200 hover:text-white transition-colors duration-300">
                <i className="fa fa-phone text-primary-400 text-lg w-5"></i>
                <p>0302503635</p>
              </div>
              <div className="flex items-center gap-3 text-dark-200 hover:text-white transition-colors duration-300">
                <i className="fa fa-envelope text-primary-400 text-lg w-5"></i>
                <p>admin@hstonline.tech</p>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="w-full py-6 text-center border-t border-dark-700/50 bg-dark-900/30">
        <p className='text-dark-300 text-sm'>
          &copy; {new Date().getFullYear()} BulkClix. All rights reserved.
        </p>
      </div>
    </footer>
  )
}

export default Footer